module.exports = require("./dz.js");